import { SIGNUP_PAGE_PATH } from '@/constant/storageKeys'
import { getWithExpiry, setWithExpiry, DAY_IN_MILLISECONDS } from '@/utils/local.storage.expiry'

const QUERY_PARAM = 'signup_page_path'
const MAX_LENGTH = 200
const TIME_TO_LIVE = 7 * DAY_IN_MILLISECONDS

function sanitize(value) {
  if (typeof value !== 'string') return null
  if (!value.startsWith('/') || value.startsWith('//') || /[?#\\]/.test(value)) return null
  if (value.length > MAX_LENGTH) return null
  return value
}

export function captureSignupPagePath(search = window.location.search) {
  const value = sanitize(new URLSearchParams(search).get(QUERY_PARAM))
  if (value) setWithExpiry(SIGNUP_PAGE_PATH, value, TIME_TO_LIVE)
}

export function getSignupPagePath() {
  return sanitize(getWithExpiry(SIGNUP_PAGE_PATH))
}

export function clearSignupPagePath() {
  try {
    localStorage.removeItem(SIGNUP_PAGE_PATH)
  } catch (error) {
    // storage unavailable
  }
}
